import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
// import Slider from 'react-slick';
import { useNavigate } from "react-router-dom";
import RBILogo from "../../../Images/SGB/sgb_RBI_LOGO.png";
import BannerLogo from "../../../Images/SGB/sgb_banner-coin.png";
import './SGBPage.css';


function CommodityTable() {
  const [show, setShow] = useState(false);
  const { BaseURL } = useContext(URLstateContext);
  const [dataWatch, setDataWatch] = useState([]);

  const [data, setData] = useState(false);
  const { BaseLiveURL } = useContext(URLstateContext);
  const [nodatafound, setnodatafound] = useState(false);

  const [loadingshow, setloadingshow] = useState(false);
  let getDataWatch, getDataaa, getDataList, getDataPer;
  let navigate = useNavigate();
  let PageSize = 5;


  useEffect(() => {
    postData('/api/Login/SGBTableBanner')
      .then((data) => {
        if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
        else { setData(null); setnodatafound(true); }
      });
  }, []);

  async function postData(url = '', data = {}) {

    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  const images = data &&
    data.map(image => {
      return (
        <img key={image.img_file} src={BaseLiveURL + "marketimages/" + image.img_file} className="img-responsive moreContent" alt="SGB_Image" />
      )
    });



    return (
    <>
      <section className="sgb_banner-section">
        <div className="container">
          <div className="row">
            {(data === null) ? <h5 className="errormsgSGB">No Data Found !!!</h5> : ''}
            {(data) && data.map(
              ({ scheme_name, priceunit, value_return, interest, tenure, liquidity, btn_name, url_link }) => (
                <>
                  <div className="col-xl-9 col-lg-8 col-md-12 ">
                    <span className="rbi-logo">
                      <img src={RBILogo} alt="SGB_logo" />
                    </span>
                    <span className="banner-head">
                      {(scheme_name != null) ? scheme_name : <h5>No data Found</h5>}
                          </span>

                    <div className="table-responsive banner-table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Price per Unit</th>
                            <th>Return</th>
                            <th>Interest</th>
                            <th>Tenure</th>
                            <th>Liquidity</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">{(priceunit != null) ? priceunit : 0}</td>
                            <td><div className="text-center"> {(value_return != null) ? value_return : 0} </div></td>
                            <td><div className="text-center"> {(interest != null) ? interest : 0} </div></td>
                            <td><div className="text-center"> {(tenure != null) ? tenure : 0} </div></td>
                            <td><div className="text-center"> {(liquidity != null) ? liquidity : 0}</div></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* <button className="bttn invest-btn">
                      <a className="sgbbtnclr" href={(url_link != null) ? url_link : "#"}>{(btn_name != null) ? btn_name : <h5>No Data Found</h5>} </a>

                    </button> */}


                    {/* code updated */}
                   <span className="bttn invest-btn d-block">
                      <a className="sgbbtnclr" href={(url_link != null) ? url_link : "#"}>{(btn_name != null) ? btn_name : <h5>No Data Found</h5>} </a>

                    </span>




                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-12 ">
                    <div className="img-container">
                      {images}
                      {nodatafound &&
                        <p className="textcenter nodata">No Image found !!!</p>
                      }
                    </div>
                  </div>
                </>
              )
            )}
          </div>
        </div>
      </section>

    </>
  )


}

export default CommodityTable